import React, { memo } from "react";
import { View, FlatList, TouchableOpacity } from "react-native";
import BackArrow from "@assets/svg/BackArrow";
import WalletFilters from "@screens/Wallet/WalletFilters";
import NoTransaction from "@assets/svg/NoTransaction";
import Text from "@components/AppText";
import { styles } from "../styles";
import WithDrawalCard from "../../Wallet/WithdrawalCard";
import StatsCard from "../../Wallet/StatsCard";
import TransactionEmpty from "../../Wallet/TransactionEmpty";

import t from "@constants/localization";
// Plotline widget removed
import testIds from "@constants/testIds";

const PATH = "screens/Passbook/View/index";

const PassbookView = memo((props = {}) => {
  const {
    passbookData = [],
    onPressOrder = () => {},
    handleApplyFilter = () => {},
    onScrollCustomerList = () => {},
    navigation = {},
  } = props || {};

  const renderPassbooksDetails = (passbookItem = {}) => {
    const DisplayCard = passbookItem.type
      ? passbookItem.type === "withdrawal"
        ? WithDrawalCard
        : StatsCard
      : null;

    return (
      <>
        <DisplayCard
          containerStyle={{
            elevation: 1,
            borderRadius: 10,
            backgroundColor: "#fff",
            borderWidth: 0,
            paddingBottom: 0,
            marginBottom: 5,
          }}
          {...passbookItem}
          shouldShowPassbookType
          typeHi={passbookItem.typeHi}
          handlePress={onPressOrder}
        />
      </>
    );
  };

  return (
    <>
      <View style={[styles.beLikeRow, styles.headContainer]}>
        <TouchableOpacity
          style={{ paddingHorizontal: 20, paddingVertical: 15 }}
          onPress={() => navigation.goBack()}
        >
          <BackArrow />
        </TouchableOpacity>
        <Text bold fontType="head2">
          {t(`${PATH}/yourPassbook`)}
        </Text>
      </View>
      {/* Plotline widget removed */}
      <WalletFilters
        onApplyFilter={handleApplyFilter}
        containerBgColor="#fff"
      />
      <FlatList
        style={styles.passbookViewContainer}
        data={passbookData}
        keyExtractor={(item) => item.id}
        onEndReached={onScrollCustomerList}
        onEndReachedThreshold={1}
        scrollEventThrottle={16}
        contentContainerStyle={{
          paddingHorizontal: 15,
          minHeight: "80%",
          paddingBottom: 40,
        }}
        renderItem={({ item }) => renderPassbooksDetails(item)}
        ListEmptyComponent={
          <TransactionEmpty
            SvgComponent={NoTransaction}
            message={t(`${PATH}/noTransactionAtSelectedTime`)}
          />
        }
      />
    </>
  );
});

export default PassbookView;
